import request from '@/utils/request'

/**
 * 查询企业授权记录（分页查询）
 * @param {page: string, limit: string, status: string} params 分页参数，页码和每页数量，状态参数（1：已授权，2：已解绑，3：已过期，空：所有状态）
 * @returns 查询企业授权记录成功返回企业授权记录集合
 */
export const getAuthorizedUserList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_SYSTEM + '/api/companyUserAuthorization/page',
		method: 'get',
		params,
		headers: {
			isToken: true
		}
	})
}

/**
 * 通过手机号或身份证号查询个人用户
 * @param {keyword: string} params 查询参数，手机号或身份证号
 * @returns 查询个人用户成功返回用户集合
 */
export const queryAuthorizedPersonalUser = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_SYSTEM + '/api/companyUserAuthorization/searchPersonalUsers',
		method: 'get',
		params,
		headers: {
			isToken: true
		}
	})
}

/**
 * 企业授权操作：绑定个人用户
 * @param {personalUserId: string} data 绑定个人用户参数
 * @returns 绑定成功返回成功信息，失败返回错误信息
 */
export const bindAuthorizedPersonalUser = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_SYSTEM + '/api/companyUserAuthorization/bind',
		method: 'post',
		data,
		headers: {
			isToken: true
		}
	})
}

/**
 * 企业或者个人用户主动解除绑定企业
 * @param {authorizationId: string} data 解绑授权记录ID参数
 * @returns 解绑成功返回成功信息，失败返回错误信息
 */
export const unbindAuthorizedUser = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_SYSTEM + '/api/companyUserAuthorization/unbind',
		method: 'post',
		data,
		headers: {
			isToken: true
		}
	})
}
